import React from "react";

export default function Statistics() {
  return (
    <div>
      <h1>Statistics</h1>
      <p>This is the Statistics component.</p>
    </div>
  );
}
